import { FIREBASE_VAPID_KEY_ENV } from "./firebaseClient";

export const PUSH_REGISTRATION_ENV =
  "REACT_APP_PUSH_REGISTRATION_ENABLED";

const VAPID_PUBLIC_KEY_PATTERN = /^[A-Za-z0-9_-]{87}$/;

function normalizedValue(environment, name) {
  const value = environment?.[name];
  return typeof value === "string" ? value.trim() : "";
}

export function isPushRegistrationEnabled(environment = process.env) {
  return (
    normalizedValue(environment, PUSH_REGISTRATION_ENV).toLowerCase() ===
    "true"
  );
}

export function getFirebaseVapidKey(environment = process.env) {
  const value = normalizedValue(environment, FIREBASE_VAPID_KEY_ENV);
  return VAPID_PUBLIC_KEY_PATTERN.test(value) ? value : null;
}

export function getPushRegistrationConfigStatus(environment = process.env) {
  const enabled = isPushRegistrationEnabled(environment);
  const vapidKey = getFirebaseVapidKey(environment);
  return {
    enabled,
    vapidConfigured: Boolean(vapidKey),
    code: !enabled
      ? "push_registration_feature_disabled"
      : vapidKey
      ? null
      : "push_registration_unavailable",
  };
}
